import { Disclosure } from "@headlessui/react";
import { ChevronDoubleDownIcon } from "@heroicons/react/24/solid";
import React from "react";
import InvoiceItemizedView from "../../InvoiceCapture/view/InvoiceItemizedView";
interface AllocationViewProps {
  allocationViewData;
}
const ReconciliationAllocationView: React.FC<AllocationViewProps> = ({
  allocationViewData,
}) => {
  return (
    <div className="w-full bg-white">
      <Disclosure>
        {({ open }) => (
          <>
            <div className="bg-white rounded-lg box-shadow">
              <div className="flex flex-row justify-between mt-2">
                <div className="text-quinary font-bold font-sans py-2 px-3">
                  Allocation Section
                </div>
                <div>
                  <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                    <ChevronDoubleDownIcon
                      className={`${
                        open ? "transform rotate-180" : ""
                      }  text-gray-500 w-5 h-5 mr-4`}
                    />
                  </Disclosure.Button>
                </div>
              </div>
              <Disclosure.Panel className="text-xxs">
                <InvoiceItemizedView rowData={allocationViewData} />
              </Disclosure.Panel>
            </div>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default ReconciliationAllocationView;
